<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-12 p-4 mb-5">

      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado de reporte anotaciones</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-success mr-3" (click)="isExportar = !isExportar"
            [attr.aria-expanded]="!isExportar">Exportar</button>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="exportar-form" *ngIf="!isExportar">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="exportarForm" (submit)="submit()">
              <div class="row">
                <div class="col-3 mb-2 input-group-prepend" formArrayName="exportarList"
                  *ngFor="let order of exportarForm.controls.exportarList.controls; let i = index">
                  <div class="input-group-text">
                    <input type="checkbox" [formControlName]="i">
                  </div>
                  <label class="label label-primary medium" for="">{{exportarList[i].name}}</label>
                </div>
                <div class="col-4 mb-2 input-group-prepend">
                  <div class="input-group-text">
                    <input type="checkbox" formControlName="selectAll">
                  </div>
                  <label class="label label-primary medium" for="">Seleccionar/Deseleccionar Todo</label>
                </div>
                <div class="col-2"></div>
                <div class="col-2">
                  <button class="btn btn-success m-auto" type="submit"
                    [disabled]="!exportarForm.valid || minFiltroCheck()">Exportar</button>
                </div>
              </div>
              <div class="row" *ngIf="!exportarForm.valid || minFiltroCheck()">
                <div class="col-12 form-group">
                  <small class="text-danger">*Para Exportar se debe de seleccionar un estado de Rnt en el filtro y
                    seleccionar minimo 1 campo del exportar</small>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group" *ngIf="!authService.getRolUser(adminCC)">
                  <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                  <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of camarasLista; let i = index"
                      value="{{option?.codigo_camara}}" [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Nit</label>
                  <input id="nit" formControlName="nit" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="numero_radicacion">Número Radicación</label>
                  <input id="numero_radicacion " formControlName="numero_radicacion" type="text"
                    class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="codigo_rnt">Número RNT</label>
                  <input id="codigo_rnt" formControlName="codigo_rnt" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="estado_rnt_id ">Estado Rnt</label>
                  <select class="form-control form-control-sm" id="estado_rnt_id" formControlName="estado_rnt_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of estadoRnt; let i = index" value="{{option?.estado_rnt_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="matricula">Número Matrícula</label>
                  <input id="matricula" formControlName="matricula" type="text" class="form-control form-control-sm">
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary mb-0" for="">Tipo solicitud</label>
                  <select class="form-control form-control-sm" id="tipo_solicitud_id"
                    formControlName="tipo_solicitud_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipoSolicitudLista; let i = index"
                      value="{{option?.tipo_solicitud_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary mb-0" for="">Estado solicitud</label>
                  <select class="form-control form-control-sm" id="estado_solicitud_id"
                    formControlName="estado_solicitud_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of estadoSolicitudLista; let i = index"
                      value="{{option?.estado_solicitud_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="tipo_anotacion_id">Tipo Anotación</label>
                  <select class="form-control form-control-sm" id="tipo_anotacion_id"
                    formControlName="tipo_anotacion_id">
                    <option class="" value="" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of tipos_anotacion; let i = index"
                      value="{{option?.tipo_anotacion_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha creación inicial</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_creacion_inicial"
                      placeholder="yyyy/mm/dd" ngbDatepicker #inicio="ngbDatepicker" (dateSelect)="onCheckDate($event)">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()"
                        type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="text-secondary small">Fecha creación final</label>
                  <div class="input-group">
                    <input class="form-control form-control-sm" formControlName="fecha_creacion_final"
                      placeholder="yyyy/mm/dd" ngbDatepicker #fin="ngbDatepicker" [minDate]="fecha_inicio">
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()" type="button"></button>
                    </div>
                  </div>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="usuario_funcionario">Funcionario</label>
                  <div class="input-group">
                    <input readonly class="form-control" formControlName="usuario_funcionario"
                      aria-describedby="add_user">
                    <div class="input-group-append">
                      <button type="button" class="btn btn-outline-secondary" (click)="onOpenModalFuncionario()"
                        id="add_user">+</button>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical" type="submit"
                    [disabled]="minFiltroCheck()">Filtrar</button>
                </div>
              </div>
              <div class="row" *ngIf="minFiltroCheck()">
                <div class="col-6 form-group">
                  <small class="text-danger">*Para filtrar se debe de seleccionar un estado de Rnt</small>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas [page]="paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems"
          (paginado)="onPaginado($event)" class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.desc_camara}}</td>
            <td>{{item.codigo_rnt}}</td>
            <td>{{item.descripcion_estado_rnt}}</td>
            <td>{{item.descripcion_tipo_rnt}}</td>
            <td>{{item.razon_social}}</td>
            <td>{{item.nit}}</td>
            <td>{{item.digito_verificacion}}</td>
            <td>{{item.matricula}}</td>
            <td>{{item.descripcion_tipo_solicitud}}</td>
            <td>{{item.descripcion_estado_solicitud}}</td>
            <td>{{item.fecha_radicacion | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>{{item.numero_radicacion}}</td>
            <td>{{item.fecha_ultima_actualizacion | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>{{item.desc_tipo_anotacion}}</td>
            <td>{{item.desc_anotacion}}</td>
            <td>{{item.fecha_creacion | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>
              <span *ngIf="item.desc_tipo_usuario === 'PRESTADOR'">Prestador:</span>
              <span *ngIf="item.desc_tipo_usuario === 'FUNCIONARIO'">Funcionario:</span>
              <span *ngIf="item.desc_tipo_usuario === 'ADMINSITRADOR CAMARA DE COMERCIO'">Admin CC:</span>
              <span *ngIf="item.desc_tipo_usuario === 'USUARIO DEPOSITARIO PROVISIONAL'">Depositario:</span>
              {{item.usuario_creacion}}
            </td>
            <td>{{item.causal_devolucion}}</td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>